"use client";

import Link from "next/link";
import { useAuth } from "@/providers/auth-provider";

interface AuthorDashboardLinkProps {
    className?: string;
}

/**
 * Footer "Author Dashboard" link. Sends signed-in users to their stories
 * list (/editor); everyone else lands on the writer signup flow.
 */
export function AuthorDashboardLink({ className }: AuthorDashboardLinkProps) {
    const { user, loading } = useAuth();
    // Until auth resolves, default to the writer signup. Once known, signed-in
    // users go to their stories list.
    const href = !loading && user ? "/editor" : "/signup/writer";

    return (
        <Link className={className} href={href}>
            Author Dashboard
        </Link>
    );
}
